import { IObservable, Subject } from '~/rage/utils';
import { ICallHistoryEntry, IPhoneCallState } from '~/shared';
import { BackendService } from '../BackendService';
import { RpcService } from '../RpcService';
import { IPhoneCallsService } from './phoneCallsServiceTypes';

export class PhoneCallsService implements IPhoneCallsService {
	private callState = new Subject<IPhoneCallState | null>(null);
	private callHistory = new Subject<ICallHistoryEntry[]>([]);

	constructor(
		private readonly rpc: RpcService,
		private readonly backend: BackendService,
	) {
		this.backend.addEventHandler(
			'phone:callStateUpdate',
			(state: IPhoneCallState | null) => {
				this.callState.next(state);
			},
		);
		this.backend.addEventHandler(
			'phone:callHistory',
			(history: ICallHistoryEntry[]) => {
				this.callHistory.next(history);
			},
		);
	}

	public getCallState(): IObservable<IPhoneCallState | null> {
		return this.callState;
	}

	public async call(number: string): Promise<void> {
		return await this.rpc.invokeServer('phone:call', { number });
	}

	public async answerCall(): Promise<void> {
		return await this.rpc.invokeServer('phone:answerCall');
	}

	public async rejectCall(): Promise<void> {
		return await this.rpc.invokeServer('phone:rejectCall');
	}

	public async endCall(): Promise<void> {
		return await this.rpc.invokeServer('phone:endCall');
	}

	public getCallHistory(): IObservable<ICallHistoryEntry[]> {
		return this.callHistory;
	}
}
